module.exports = new __parcel__URL__("45758_sq.91c903b9.jpg").toString();